import { Tooltip } from '@mui/material'
import React from 'react'
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const SupplyOrderItemReceivedShort = ({ isReceivedAll }) => {
  return (
    <div className='supplyAgrees__column'>
        {
            isReceivedAll && isReceivedAll === 'receivedAll' ?
                <p className={`supplyAgrees__agree `}>
                    <Tooltip title='Всі позиції доставлені'>
                        <LocalShippingIcon />
                    </Tooltip>
                </p>
            :
            isReceivedAll && isReceivedAll === 'receivedPart' ?
                <p className={`supplyAgrees__approval `}>
                    <Tooltip title='Позиції доставлені частково'>
                        <LocalShippingIcon />
                    </Tooltip>
                </p>
            : 
            isReceivedAll && isReceivedAll === 'notReceived' ?
                <p className={` `}>
                    <Tooltip title='Немає доставлених позицій'>
                        <LocalShippingIcon />
                    </Tooltip>
                </p>
            : ''
        }
    </div>
  )
}

export default SupplyOrderItemReceivedShort